export enum SiteCodes {
  JaycarAu = 'jrau',
  JaycarNz = 'jrnz',
  RTM = 'rtau',
}
